module.exports = __webpack_public_path__ + "img/chat_send_btn.9846cd11.svg";